import { ApiService, FileUploadService } from "../../../config/apiServices";
import { CIRCULAR_ADMIN_URL } from "../../../config/adminUrlConfig";

export const getCirculars = (page = 1, search = "") => {
  let url = `${CIRCULAR_ADMIN_URL}?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  return ApiService.get(url);
};

export const createCircular = (formData) =>
  FileUploadService.post(CIRCULAR_ADMIN_URL, formData);

export const updateCircular = (id, formData) =>
  FileUploadService.post(`${CIRCULAR_ADMIN_URL}/${id}`, formData);

export const deleteCircular = (id) =>
  ApiService.delete(`${CIRCULAR_ADMIN_URL}/${id}`);

export const toggleCircularStatus = (id) =>
  ApiService.get(`${CIRCULAR_ADMIN_URL}/${id}/toggle-status`);
